import { render, staticRenderFns } from "./CmgRewardsExtrasBody.vue?vue&type=template&id=00778bb6&scoped=true&lang=pug&"
import script from "./cmg-rewards-extras-body.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-extras-body.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExtrasBody.vue?vue&type=style&index=0&id=00778bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00778bb6",
  null
  
)

export default component.exports